import React from "react";
import Skeleton from "react-loading-skeleton";
import { toTitleCase } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import { CamIcon, PPEIcon } from "../../assets/Icons";

const AreaBoxes = ({ instanceList, loading, modelList }) => {
  const navigate = useNavigate();

  return (
    <div className="list-here">
      {!loading ? (
        <>
          {instanceList?.map((item) => (
            <div
              key={item.id}
              className="list-box"
              onClick={() => {
                const modelName = modelList?.find((model) => model.code === item.modelId);
                navigate(
                  `/monitoring/${item.uuid}?area=${item.area.name}&model=${modelName?.name ? modelName.name : ""}`
                );
              }}
            >
              <div className="area-card">
                <img class="default-img-centered" src={item?.image} alt="" />
                <p className="name-tag"> {toTitleCase(item?.name)} </p>
              </div>
              <div className="area-detail">
                <p>
                  <CamIcon />
                  {item.area?.name}
                </p>

                <p>
                  <PPEIcon />
                  PPE Detection
                </p>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {Array(6)
            .fill(0)
            .map((_, index) => (
              <div key={index} className="list-box">
                <div className="area-card">
                  <p className="name-tag ps-2">
                    <Skeleton width="15rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                  </p>
                </div>
                <div className="d-flex align-items-start justify-content-start flex-column p-2 ps-3 gap-1">
                  <Skeleton width="15rem" className="text-left" baseColor="#ebebeb" highlightColor="#ffffff" />
                  <Skeleton width="15rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                </div>
              </div>
            ))}
        </>
      )}
    </div>
  );
};

export default AreaBoxes;
